import { useEffect, useRef, useState } from "react";
import { BotMessageSquare } from "./icones";
import css from "./JanelaDoAssistente.module.css";
// Casca visual do chat flutuante (orbe + janela de diálogo), portada do Portal da Cidade com os
// PRs #350 (janela 25% maior) e #352 (campo bloqueado quando o chamado é encerrado).
function prenderFoco(e, raiz) {
  const focaveis = raiz?.querySelectorAll("a[href], button:not([disabled]), input:not([disabled])");
  if (!focaveis?.length) return;
  const primeiro = focaveis[0];
  const ultimo = focaveis[focaveis.length - 1];
  if (e.shiftKey && document.activeElement === primeiro) {
    e.preventDefault();
    ultimo.focus();
  } else if (!e.shiftKey && document.activeElement === ultimo) {
    e.preventDefault();
    primeiro.focus();
  }
}
export function IconeIA() {
  return <BotMessageSquare size={28} />;
}
export default function JanelaDoAssistente({
  aberto,
  aoAbrir,
  aoFechar,
  titulo,
  subtitulo,
  rodape,
  placeholder,
  children,
  fimRef,
  texto,
  aoMudarTexto,
  aoEnviar,
  ocupado = false,
  maxCaracteres,
  acaoDoCabecalho,
  antesDoForm,
  barra,
  icone,
  aviso,
  grande = false,
  anexo,
  aoColar,
  enviarSemTexto = false,
  bloqueado = false,
}) {
  const campo = useRef(null);
  const circulo = useRef(null);
  const dialogo = useRef(null);
  const estavaAberto = useRef(false);
  // No computador o foco vai para o campo; em tela de toque, para a janela (focar o campo abriria
  // o teclado e daria zoom no iPhone). Ao fechar, o foco volta ao orbe.
  useEffect(() => {
    if (aberto) {
      estavaAberto.current = true;
      const toque = window.matchMedia?.("(pointer: coarse)").matches === true;
      if (toque) dialogo.current?.focus();
      else campo.current?.focus();
    } else if (estavaAberto.current) {
      estavaAberto.current = false;
      circulo.current?.focus();
    }
  }, [aberto]);
  // Teclado do celular aberto: a janela ocupa só a área visível.
  const [areaVisivel, setAreaVisivel] = useState(null);
  useEffect(() => {
    const vv = aberto ? window.visualViewport : null;
    if (!vv) return;
    const medir = () => {
      const tecladoAberto = window.innerHeight - vv.height > 120;
      setAreaVisivel(tecladoAberto ? { topo: vv.offsetTop, altura: vv.height } : null);
    };
    vv.addEventListener("resize", medir);
    vv.addEventListener("scroll", medir);
    return () => {
      vv.removeEventListener("resize", medir);
      vv.removeEventListener("scroll", medir);
    };
  }, [aberto]);
  if (!aberto) {
    return (
      <div className={css.orbeArea} data-suporte-ia>
        <div className={css.orbeCaixa}>
          <button
            type="button"
            aria-label={aviso ? `Abrir ${titulo}: ${aviso.texto}` : `Abrir ${titulo}`}
            title={aviso?.texto}
            onClick={aoAbrir}
            ref={circulo}
            className={css.orbe}
          >
            <span aria-hidden="true" className={css.miolo} />
            <span className={css.iconeDoOrbe}>{icone ?? <IconeIA />}</span>
            {aviso ? (
              <span aria-hidden="true" className={css.selo}>
                {aviso.quantos}
              </span>
            ) : (
              <span aria-hidden="true" className={css.pontoVerde} />
            )}
          </button>
        </div>
      </div>
    );
  }
  return (
    <div
      ref={dialogo}
      role="dialog"
      data-suporte-ia
      aria-modal="true"
      aria-label={titulo}
      tabIndex={-1}
      style={areaVisivel ? { top: areaVisivel.topo + 8, bottom: "auto", height: areaVisivel.altura - 16 } : undefined}
      onKeyDown={(e) => {
        if (e.key === "Escape") aoFechar();
        if (e.key === "Tab") prenderFoco(e, dialogo.current);
      }}
      className={`${css.janela}${grande ? ` ${css.grande}` : ""}`}
    >
      <div aria-hidden="true" className={css.faixa} />
      <div className={css.cabecalho}>
        <span aria-hidden="true" className={css.avatar}>
          <span className={css.miolo} />
          <span className={css.iconeDoOrbe}>{icone ?? <IconeIA />}</span>
        </span>
        <div className={css.cabecalhoTexto}>
          <p className={css.titulo}>{titulo}</p>
          <p className={css.subtitulo}>
            <span aria-hidden="true" className={css.online} />
            {subtitulo}
          </p>
        </div>
        <div className={css.acoes}>
          {acaoDoCabecalho}
          <button type="button" aria-label="Fechar o assistente" onClick={aoFechar} className={css.fechar}>
            <span aria-hidden="true">✕</span>
          </button>
        </div>
      </div>

      <div aria-live="polite" className={css.rolagem}>
        {children}
        <div ref={fimRef} />
      </div>

      {antesDoForm}
      {barra}
      <form
        onSubmit={(e) => {
          e.preventDefault();
          aoEnviar();
        }}
        className={css.form}
      >
        {anexo}
        <label htmlFor="assistente-ia-mensagem" className={css.srOnly}>
          Sua mensagem
        </label>
        <input
          id="assistente-ia-mensagem"
          ref={campo}
          value={texto}
          onChange={(e) => aoMudarTexto(e.target.value)}
          onPaste={aoColar}
          maxLength={maxCaracteres}
          autoComplete="off"
          placeholder={placeholder}
          disabled={bloqueado}
          className={css.campo}
        />
        <button
          type="submit"
          aria-label="Enviar mensagem"
          disabled={bloqueado || ocupado || (!texto.trim() && !enviarSemTexto)}
          className={css.enviar}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M5 12h14M13 6l6 6-6 6" />
          </svg>
        </button>
      </form>
      <p className={css.rodape}>{rodape}</p>
    </div>
  );
}
